// DS: MO0.3
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import isNumber from 'lodash/isNumber';
import { URLS } from '@wix/da-url';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import DollarSignIcon from '@wix/da-ds/pkg/Icons/16x16/DollarSign';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { MIN_PRICE_TO_ACCEPT_DOLLARS, MAX_CORE_PRO_AND_CORE_PRO_PLUS } from '../utils/profits';
import s from './DollarPriceInput.scss';
export const DollarPriceInput = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { value = '', name = 'price', label, placeholder = 0, postfix, details, error, min = 0, max = MAX_CORE_PRO_AND_CORE_PRO_PLUS, forceInteger, hidePointsInfo, onChange, className, inputClassName } = _param, remainingInputProps = _object_without_properties(_param, [
        "value",
        "name",
        "label",
        "placeholder",
        "postfix",
        "details",
        "error",
        "min",
        "max",
        "forceInteger",
        "hidePointsInfo",
        "onChange",
        "className",
        "inputClassName"
    ]);
    const { t } = useTranslation();
    const id = useUniqueId();
    const chargedInPoints = !!value && +value > 0 && +value < MIN_PRICE_TO_ACCEPT_DOLLARS;
    const chargedInPointsHint = chargedInPoints && !hidePointsInfo && /*#__PURE__*/ React.createElement("div", {
        className: s['points-hint']
    }, t('common.dollarPriceInput.warning.pointsOnly', {
        value: MIN_PRICE_TO_ACCEPT_DOLLARS
    }), ' ', /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        target: "_blank",
        href: URLS.ABOUT_POINTS,
        className: s['what-are-points']
    }, t('common.faq.whatArePoints')));
    const onChangeHandler = useCallback((ev)=>{
        const numericValue = parseFloat(ev.target.value);
        // Set a limit to how high a price the user is allowed to type.
        // This is separate from the actual field validation which usually takes place in the form.
        const newValue = isNaN(numericValue) ? '' : numericValue > max ? `${max}` : forceInteger ? numericValue.toFixed(0) : ev.target.value;
        onChange(newValue);
    }, [
        forceInteger,
        max,
        onChange
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['price-input-line']
    }, /*#__PURE__*/ React.createElement(TextInput, _object_spread({
        id: id,
        type: "number",
        name: name,
        wrapperClassName: classnames(s['price-input'], inputClassName),
        value: value,
        validationResult: error ? 'error' : undefined,
        details: error || chargedInPointsHint || details,
        onChange: onChangeHandler,
        prefix: /*#__PURE__*/ React.createElement(DollarSignIcon, {
            disableDefaultColors: true
        }),
        postfix: /*#__PURE__*/ React.createElement("div", {
            className: s['price-input-postfix']
        }, postfix || t('common.dollarPriceInput.postfix')),
        placeholder: isNumber(placeholder) ? placeholder > 0 ? `${placeholder}` : undefined : placeholder,
        label: label || t('common.dollarPriceInput.inputLabel.v2'),
        min: min,
        max: max,
        step: 1,
        maxLength: 8,
        maxLengthHidden: true,
        autoComplete: "off",
        ref: ref
    }, remainingInputProps))));
});
DollarPriceInput.displayName = 'DollarPriceInput';
export default DollarPriceInput;

//# sourceMappingURL=DollarPriceInput.js.map